if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            try {
              // item = the line-item object from your fetch('/cart/add.js') or fetch('/cart/update.js') response
              const item = response; // <-- replace addedItem with your actual variable

              console.log("item",item);
              // Helper: detect option value even if name changes
              const getOptionValue = (keyword) => {
                return item.options_with_values?.find(opt =>
                  opt.name.toLowerCase().includes(keyword.toLowerCase())
                )?.value || "NA";
              };

              // Dynamic variant options
              const itemFirmness = getOptionValue("firmness");
              const itemSize = getOptionValue("size");
              const itemHeight = getOptionValue("height");

              // Basic product data
              const productTitle = item.product_title || "NA";
              const sku = item.sku || "NA";
              // let quantity = item.quantity || 1;
              let quantity = 1;
              if(document.querySelector(`quantity-input [name="quantity"]`)){
                quantity = parseInt(document.querySelector(`quantity-input [name="quantity"]`).value);
              }

              // Price (Shopify returns in cents)
              let price = item.price ? item.price / 100 : 0;
              if(document.querySelector(`.product__info-wrapper [data-regular-price]`) && document.querySelector(`.product__info-wrapper [data-regular-price]`).dataset.regularPrice != ""){
                price = parseFloat(document.querySelector(`.product__info-wrapper [data-regular-price]`).dataset.regularPrice);
              }
              const compareAt = item.original_price ? item.original_price / 100 : price;

              const discount = compareAt > price
                ? parseFloat((compareAt - price).toFixed(2))
                : 0;

              // Category mapping
              const itemCategory = item.product_type || "NA";
              // const itemCategory2 = item.vendor || "NA";
              const itemCategory2 = itemCategory;
              const itemCategory3 = item.options_with_values?.[0]?.value || "NA";

              const itemListId = localStorage.getItem(`item_list_id_${item.product_id}`) || 'NA';
              const itemListName = localStorage.getItem(`item_list_name_${item.product_id}`) || 'NA';

              // User info
              const userId = Shopify?.customer?.id || undefined;
              const userStatus = userId !== "NA" ? "logged_in" : "guest";

              window.dataLayer = window.dataLayer || [];

              // Clear previous ecommerce
              window.dataLayer.push({ ecommerce: null });

              let obj = {
                index: parseInt(localStorage.getItem(`index_${item.product_id}`)) || 1,
                item_brand: 'Stosi',
                item_id: `${item.product_id}`,
                item_name: productTitle,
                item_variant: itemSize,
                price: price,
                discount: document.querySelector('script[data-discount]') ? parseFloat(document.querySelector('script[data-discount]').dataset.discount.trim()) : 0,
                quantity: 1,
                item_category: itemCategory,
                item_category2: document.querySelector('script[data-item_category2]') ? document.querySelector('script[data-item_category2]').dataset.item_category2.trim() : "NA",
                item_category3: document.querySelector('script[data-item_category3]') ? document.querySelector('script[data-item_category3]').dataset.item_category3.trim() : "NA",
                item_category4: 'NA',
                item_category5: 'NA',
                item_list_id: itemListId,
                item_list_name: itemListName
              }
              localStorage.setItem(`datalayer_${item.product_id}`,JSON.stringify(obj));
              // GA4 EVENT
              console.log("obj",obj);
              window.dataLayer.push({
                event: "add_to_cart_ce",
                page_type: getPageType(),
                user_id_event: getUserId(),
                user_status: getUserType(),
                platform: getPlatform(),
                // total_qty: quantity,
                ecommerce: {
                  currency: Shopify?.currency?.active || "USD",
                  value: price,
                  items: [
                    obj
                  ]
                }
              });

            } catch (err) {
              console.warn("GA4 add_to_cart error:", err);
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
